'use client';

import { useState, useCallback, useEffect } from 'react';

var useElementOnScreen = function (props) {
    var target = props.target, options = props.options;
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var isUseReactRef = props.options && props.options.isUseReactRef !== undefined ? props.options.isUseReactRef : true;
    var _b = useState(false), isElementOnScreen = _b[0], setElementOnScreen = _b[1];
    var callbackObserve = useCallback(function (entities) {
        var entry = entities[0];
        setElementOnScreen(entry.isIntersecting);
        if (entry.isIntersecting && (options === null || options === void 0 ? void 0 : options.runOnce)) {
            setEnable(false);
        }
    }, [options === null || options === void 0 ? void 0 : options.runOnce]);
    useEffect(function () {
        // on mount
        if (target === undefined || target === null) {
            return;
        }
        if (typeof window === 'undefined') {
            return;
        }
        if (options === null) {
            return;
        }
        if (!enable) {
            return;
        }
        var intersectionObserver = null;
        if (typeof window.IntersectionObserver !== 'undefined') {
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            intersectionObserver = new IntersectionObserver(callbackObserve, options);
            intersectionObserver.observe(isUseReactRef ? target.current : target);
        }
        return function () {
            // on disMount
            if (target === undefined || target === null) {
                return;
            }
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return;
            }
            if (intersectionObserver !== null) {
                intersectionObserver.unobserve(isUseReactRef ? target.current : target);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, enable]);
    return [isElementOnScreen];
};

export { useElementOnScreen as default };
//# sourceMappingURL=index.js.map
